import { UUID } from "../utils";
import Country from "./Country";
import { CountryCode } from "./CountryCode";
import CustomerAddress from "./CustomerAddress";
import CustomerCredentials from "./CustomerCredentials";
import CustomerPreferences from "./CustomerPreferencesBranding";

export const CUSTOMER_PSP: "payment_services_provider" =
  "payment_services_provider";
export const CUSTOMER_DIVISION: "division" = "division";
export const CUSTOMER_MERCHANT: "merchant" = "merchant";
export const CUSTOMER_APPLICATION_DEVELOPER: "application_developer" =
  "application_developer";
export const CUSTOMER_VOLT: "customer" = "customer";

export type CustomerDiscriminator =
  | typeof CUSTOMER_PSP
  | typeof CUSTOMER_DIVISION
  | typeof CUSTOMER_MERCHANT
  | typeof CUSTOMER_APPLICATION_DEVELOPER
  | typeof CUSTOMER_VOLT;

export const CustomerDiscriminatorList: CustomerDiscriminator[] = [
  CUSTOMER_PSP,
  CUSTOMER_DIVISION,
  CUSTOMER_MERCHANT,
  CUSTOMER_APPLICATION_DEVELOPER,
  CUSTOMER_VOLT,
];

export default interface Customer {
  id: UUID;
  active: boolean;
  discr: CustomerDiscriminator;
  parent?: UUID | null;
  accountNumber: string;
  countryCode: CountryCode;
  country: Country;
  name: string;
  children?: Customer[];
  credentials?: CustomerCredentials;
  preferences?: CustomerPreferences;
  createdAt: string;
  address?: CustomerAddress;
}
